import { createContext } from 'react';
export var currentPrimaryDimensionIndexContext = createContext(0);
